import { render } from "./MenuAyuda.vue?vue&type=template&id=4e56e986"
import script from "./MenuAyuda.vue?vue&type=script&lang=js"
export * from "./MenuAyuda.vue?vue&type=script&lang=js"

import exportComponent from "/home/nodejs/front/oxyplus-acuicultura-monitorweb/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__